/* eslint-disable @typescript-eslint/no-explicit-any */
import { TaxRateModel } from "../../Utils/Models";
import { useEffect, useRef, useState } from "react";
import AddOrUpdateModel from "../GenericComponents/AddOrUpdateModel";
import { Vocabulary } from "../../Utils/Vocabulary";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { Grid } from "@mui/material";
import { onChangeTextField } from "../../Utils/Utils";

type TaxRateProps = {
  editTaxRate: TaxRateModel | null;
  open: boolean;
  addOrUpdateTaxRate: (taxRate: TaxRateModel | null) => void;
  onClose: () => void;
};
export default function TaxRate(props: TaxRateProps) {
  const { editTaxRate, open, addOrUpdateTaxRate, onClose } = props;
  const ref: any = useRef();
  const [taxRate, setTaxRate] = useState<TaxRateModel>(new TaxRateModel());
  const [pressOnSubmit, setPressOnSubmit] = useState(false);

  /**
   *
   */
  useEffect(() => {
    if (editTaxRate) {
      setTaxRate(editTaxRate);
    } else {
      setTaxRate(new TaxRateModel());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editTaxRate]);

  /**
   *
   */
  useEffect(() => {
    if (pressOnSubmit) {
      ref.current.submit();
      //reset the value
      handleChangePressOnSubmit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pressOnSubmit]);

  /**
   *
   */
  function handleChangePressOnSubmit() {
    setPressOnSubmit(!pressOnSubmit);
  }

  return (
    <ValidatorForm ref={ref} onSubmit={() => addOrUpdateTaxRate(taxRate)}>
      <AddOrUpdateModel
        open={open}
        title={Vocabulary.taxRate}
        onClose={onClose}
        isSubmit={true}
        addOrUpdateItem={() => null}
        handleChangePressOnSubmit={handleChangePressOnSubmit}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextValidator
              size="small"
              id="name"
              name="name"
              label={Vocabulary.name}
              fullWidth
              variant="outlined"
              value={taxRate.name}
              validators={["required"]}
              errorMessages={[Vocabulary.requiredField]}
              onChange={(event: any) =>
                setTaxRate(onChangeTextField(event, taxRate))
              }
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextValidator
              size="small"
              id="value"
              name="value"
              label={Vocabulary.value}
              fullWidth
              variant="outlined"
              value={taxRate.value}
              validators={["required"]}
              errorMessages={[Vocabulary.requiredField]}
              onChange={(event: any) =>
                setTaxRate(onChangeTextField(event, taxRate))
              }
            />
          </Grid>
        </Grid>
      </AddOrUpdateModel>
    </ValidatorForm>
  );
}
